import React from 'react';
import Badge from '../Badge';
import { TbCircleCheckFilled } from 'react-icons/tb';
import SlotStepProduct from './SlotStepProduct';
import { useCartContext } from '../../../Contexts/CartContext';
import { useOrderTypeContext } from '../../../Contexts/OrderTypeContext';

interface SlotStepProps {
  product: any;
  step: any;
  className?: string;
}

const SlotStep = ({
  product,
  step,
  className

}: SlotStepProps) => {

  const { getTotalSelectedComplements, cartDisplay } = useCartContext();
  const { isStoreCounter } = useOrderTypeContext();

  return (
    <div className='flex flex-col ring-1 ring-gray-100 rounded-lg'>
      <div className='sticky grid top-16 z-20 md:top-0 rounded-t bg-gray-50 p-3 w-full flex gap-1 w-full'>

          <div className='flex justify-between items-center text-left text-md'>
            <h4 className='grid'>
              <span className='text-lg md:text-xl text-custom-primary font-bold leading-5'>{step.name}</span>
            </h4>

            <div className='flex items-center gap-0.5 self-start'>
              {(!isStoreCounter || (isStoreCounter && cartDisplay)) &&
                <>
                  {(step.required && getTotalSelectedComplements(step.id) < step.minimum_quantity) && <Badge type='required' className='text-xs'>Obrigatório</Badge>}
                  {(step.required && getTotalSelectedComplements(step.id) >= step.minimum_quantity) && <TbCircleCheckFilled size={22} className={'text-shopfood-success zoomInIcon'} />}
                  <Badge outline={getTotalSelectedComplements(step.id) >= step.minimum_quantity} type={getTotalSelectedComplements(step.id) >= step.minimum_quantity ? 'success' : ''} className='flex justify-center text-nowrap text-sm'>{getTotalSelectedComplements(step.id)} / { step.quantity }</Badge>
                </>
              }
            </div>
          </div>

          {step.description && <span className='text-sm text-left text-gray-500 leading-4 mb-1'>{ step.description }</span>}
          {(!isStoreCounter || (isStoreCounter && cartDisplay)) && 
            <span className='text-sm font-medium text-gray-400 flex gap-1 leading-5'>
              <span>
                  {step.minimum_quantity
                        ? `Escolha pelo menos ${step.minimum_quantity} ${step.minimum_quantity > 1 ? 'itens' : 'item'}`
                        : `Escolha  ${step.required && step.minimum_quantity && (step.minimum_quantity !== step.quantity)
                                      ? `de ${step.minimum_quantity} até ${step.quantity}` 
                                      :  `${step.quantity} ${step.quantity > 1 ? 'itens' : 'item'}`
                                    }`
                  }
              </span>
            </span>
          }

      </div>

      <div className={`text-left grid gap-4 ${className}`}>
        <section className='grid divide-y divide-gray-50 md:ring-1 ring-inset ring-gray-50 rounded-b-lg'>
          {step.complements.map((complement: any, index: number) => 
            <SlotStepProduct product={product} complement={complement} step={step} key={index} />
          )}
        </section>
      </div>
    </div>

  )
}

export default SlotStep;